export const setCarouselEntitiesOutsideInitialView = (
  entities: any[],
  outsideInitialView: boolean
): any[] => {
  const isInCarousel = entities.find(e => e.type == "carousel");
  if (isInCarousel) {
    const cardEntity = entities.find(e => e.type == "product_card" || e.type == "content_card");
    if (cardEntity) {
      const cardEntityIndex = entities.indexOf(cardEntity);

      cardEntity.outsideInitialView = outsideInitialView;
      entities[cardEntityIndex] = cardEntity;
    }
  }
  return entities;
};
